export default __webpack_public_path__ + "static/media/arrowDown.ce56c90e.svg";